<template>
  <b-modal
    id="modal-buzzer-setting"
    modal-class="modal-buzzer-setting"
    size="sm"
    centered
    scrollable
    hide-footer
    :title="$t('cdmSecurityMonitoring.modal.buzzerSetting.title')"
    @close="$emit('onClose')"
  >
    <div class="w-100 d-flex gap-2 justify-content-center">
      <McButton
        icon="icon-outline_bell"
        variant="secondary"
        :text="$t('cdmSecurityMonitoring.action.enable')"
        :disabled="isMutating"
        @click="handleEnableBuzzer"
      />
      <McButton
        icon="icon-outline_bell-off"
        variant="secondary"
        :text="$t('cdmSecurityMonitoring.action.disable')"
        :disabled="isMutating"
        @click="handleDisableBuzzer"
      />
    </div>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
import { SET_BUZZER_STATUS } from '@/services/api/cdm/deviceStatuses'
import { BUZZER_STATUS } from '../libs/constants'

export default {
  components: {
    McButton,
  },
  props: {
    vehicleId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isMutating: false,
    }
  },
  methods: {
    handleClose() {
      this.$emit('onClose')
    },
    async handleBuzzerStatus(setBuzzerTo) {
      if (this.isMutating) return
      if (this.vehicleId === null || this.vehicleId === undefined) return

      this.isMutating = true
      try {
        const result = await this.$apollo.mutate({
          mutation: SET_BUZZER_STATUS,
          variables: {
            input: {
              setBuzzerTo,
              vehicleId: this.vehicleId,
            },
          },
        })

        if (!result?.data?.setBuzzerStatus?.isSuccessful) return

        const notificationKey =
          setBuzzerTo === BUZZER_STATUS.ENABLE
            ? 'cdmSecurityMonitoring.notification.buzzerEnabled'
            : 'cdmSecurityMonitoring.notification.buzzerDisabled'
        this.$mcToast.success(this.$t(notificationKey))

        this.$bvModal.hide('modal-buzzer-setting')
        this.$emit('onClose')
      } finally {
        this.isMutating = false
      }
    },
    async handleEnableBuzzer() {
      await this.handleBuzzerStatus(BUZZER_STATUS.ENABLE)
    },
    async handleDisableBuzzer() {
      await this.handleBuzzerStatus(BUZZER_STATUS.DISABLE)
    },
  },
}
</script>
